import '../stylesheets/api_docs.scss'

import '../javascript/api_docs/highlight/bash.js'
import '../javascript/api_docs/highlight/json.js'
import '../javascript/api_docs/highlight/shell.js'
import hljs from '../javascript/api_docs/highlight/highlight.js'
import '../javascript/api_docs/all.js'

import '../images/logo.svg'
import '../images/navbar.png'

hljs.highlightAll();